import type { FC } from 'react';
import React, { useState, useEffect } from 'react';

import { DraftProvider } from './context';
import { classes } from './classes';
import type { IProps } from './models';
import { DEFAULT_STATE } from './config';

export const Draft: FC<IProps> = ({ children, classDraft, cookieName, products, scenario }) => {
    const [state, setState] = useState(DEFAULT_STATE);

    const createClass = classDraft || classes[scenario];

    useEffect(
        () =>
            new createClass({
                cookieName,
                products,
                setState,
            }).parseCookie(),
        [cookieName, products, scenario]
    );

    return <DraftProvider value={state}>{children}</DraftProvider>;
};
